import { ClientDetailModel } from 'lemunzo-api';

/**
 * Unifies how a client profile is labelled in the UI: the person's full name for individuals,
 * the company name for organizations, an '-' when neither is present.
 * @param clientProfile the client profile to be labelled
 */
export function getDisplayName(clientProfile: ClientDetailModel): string {
    if (clientProfile.person) {
        return `${clientProfile.person.givenName} ${clientProfile.person.familyName}`;
    } else if (clientProfile.organization) {
        return clientProfile.organization.companyName;
    }

    return '-';
}
